import { CupModeFormatBase } from "model/Match/Set/CupMode/Format/CupModeFormat";
import { mapSetFormatBase } from "../FsSetFormat";
import { mapCupModePoints } from "./FsCupModePoints";
import { FsCupModeFormatBase } from "db/model/match/Set/CupMode/FsCupModeFormat";

export const mapCupModeFormatBase = (
  fsModel: FsCupModeFormatBase
): CupModeFormatBase | undefined => {
  const base = mapSetFormatBase(fsModel);
  if (!base || !fsModel.points) {
    return undefined;
  }

  const points = mapCupModePoints(fsModel.points);
  if (!points) {
    return undefined;
  }

  return {
    ...base,
    numTracks: fsModel.numTracks,
    playTillLeft: fsModel.playTillLeft,
    playTillFinished: fsModel.playTillFinished,
    points,
    roundsPerTrack: fsModel.roundsPerTrack,
  };
};
